import {
  PortalContextBridgeContent,
  usePortalContextValues,
} from "@-/dev.improve.haniverse.components.ui.portal-context-bridge";
import { PrimaryControlsStripExpansion } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.expansion";
import type { PropsWithChildren } from "react";

/**
 * Publishes header expansion content via `PrimaryControlsStripExpansion` while keeping every context
 * available above this component (including the levels layout provider) accessible inside the
 * published subtree. The host renders outside this layout's provider tree, so we bridge the
 * fiber upward and replay it under `PrimaryControlsStripExpansion`.
 */
export function BrowseLevelsLayoutContextBridge({ children }: PropsWithChildren) {
  const contextValues = usePortalContextValues();
  return (
    <PrimaryControlsStripExpansion>
      <PortalContextBridgeContent values={contextValues}>{children}</PortalContextBridgeContent>
    </PrimaryControlsStripExpansion>
  );
}
